import { useEffect, useState } from "react";

export default function useTournamentWeek({
  db,
  doc,
  getDoc,
  isISODate,
  startOfWeekMonday,
}) {
  const [twLoading, setTwLoading] = useState(true);
  const [twStartISO, setTwStartISO] = useState("");
  const [twEndISO, setTwEndISO] = useState("");
  const [initialWeekStart, setInitialWeekStart] = useState(() =>
    startOfWeekMonday(new Date())
  );

  useEffect(() => {
    let cancelled = false;

    async function loadTournamentWeek() {
      setTwLoading(true);
      try {
        const ref = doc(db, "appConfig", "tournamentWeek");
        const snap = await getDoc(ref);

        if (cancelled) return;

        if (snap.exists()) {
          const data = snap.data() || {};
          const s = data.startDate;
          const e = data.endDate;

          if (isISODate(s)) {
            setTwStartISO(s);
            setTwEndISO(isISODate(e) ? e : "");
            setInitialWeekStart(startOfWeekMonday(new Date(`${s}T00:00:00`)));
          } else {
            setTwStartISO("");
            setTwEndISO("");
          }
        } else {
          setTwStartISO("");
          setTwEndISO("");
        }
      } catch (e) {
        console.warn("Tournament week config load failed:", e?.message || e);
        setTwStartISO("");
        setTwEndISO("");
      } finally {
        if (!cancelled) setTwLoading(false);
      }
    }

    loadTournamentWeek();

    return () => {
      cancelled = true;
    };
  }, [db, doc, getDoc, isISODate, startOfWeekMonday]);

  return {
    twLoading,
    twStartISO,
    twEndISO,
    initialWeekStart,
  };
}